import Vue from 'vue'
import Router from 'vue-router'
import Privacy from './../module/privacy/Privacy.vue'
import UserService from '../module/privacy/UserService.vue'
import AboutUs from './../module/aboutus/AboutUs.vue'
import Ad from '../module/ad/Ad.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/user_service',
      name: 'UserService',
      component: UserService
    },
    {
      path: '/aboutus',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/ad',
      name: 'Ad',
      component: Ad
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js